module.exports = __webpack_public_path__ + "static/media/cl2-icon-download.789aff1f.svg";